module.exports = __webpack_public_path__ + "ava.e7ff03451dd78c1b7364.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ava.ttf
// module id = ./src/assets/webfonts/ava.ttf
// module chunks = styles